<div
  id="forgot-password-finish"
  class="inner-scroll"
  fxLayout="row"
  fxLayoutAlign="start"
>
  <app-wellcome />
  <div
    id="forgot-password-form-wrapper"
    [@animate]="{ value: '*', params: { delay: '300ms', x: '100%' } }"
  >
    <div id="forgot-password-form">
      <div class="logo" fxHide.gt-xs>
        <img src="assets/images/logos/fuse.svg" />
      </div>
      <div *ngIf="isProcessOk">
        <div class="title">
          {{
            this.step === forgStep.registerNewPassword
              ? 'NUEVA SEGURIDAD'
              : 'NUEVO PIN
                    SEGURIDAD'
          }}
          <mat-icon
            matSuffix
            [matTooltip]="
              this.step === forgStep.registerNewPassword
                ? 'Crea una nueva contraseña de seguridad'
                : 'Crea un PIN en caso de olvidar tu contraseña'
            "
            style="font-size: 16px; color: grey"
            onmouseover="this.style.color='darkcyan'"
            onmouseout="this.style.color='grey'"
            >info</mat-icon
          >
        </div>
        <div *ngIf="isForm">
          <form
            name="forgotPasswordForm"
            autocomplete="off"
            [formGroup]="forgotPasswordForm"
            novalidate
          >
            <div [hidden]="step !== forgStep.registerNewPassword">
              <mat-form-field appearance="outline">
                <mat-label>Contraseña</mat-label>
                <input
                  matInput
                  [type]="showPassword ? 'text' : 'password'"
                  autocomplete="none"
                  maxlength="16"
                  formControlName="newPassword"
                  required
                />
                <button
                  (click)="checkPassword()"
                  matSuffix
                  mat-icon-button
                  aria-label="mostrar"
                  type="button"
                  [matTooltip]="getPasswordErrorTooltip()"
                  [ngClass]="{ 'error-icon': hasPasswordError() }"
                >
                  <mat-icon>remove_red_eye</mat-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Confirmar Contraseña</mat-label>
                <input
                  matInput
                  [type]="showPassword ? 'text' : 'password'"
                  autocomplete="none"
                  formControlName="passwordConfirm"
                  required
                />
                <mat-icon
                  matSuffix
                  class="secondary-text"
                  [matTooltip]="getPasswordConfirmErrorTooltip()"
                  [ngClass]="{ 'error-icon': hasPasswordConfirmError() }"
                  *ngIf="
                    forgotPasswordForm
                      .get('passwordConfirm')!
                      .hasError('required') ||
                    (!forgotPasswordForm
                      .get('passwordConfirm')!
                      .hasError('required') &&
                      forgotPasswordForm
                        .get('passwordConfirm')!
                        .hasError('passwordsNotMatching'))
                  "
                  >error</mat-icon
                >
              </mat-form-field>

              <div fxLayout="row" fxLayoutAlign="center">
                <button
                  mat-raised-button
                  color="primary"
                  class="next w-button"
                  [disabled]="(!showNextButton && !formValidStep()) || loading"
                  (click)="verifyNewPassword()"
                >
                  <span *ngIf="!loading">Siguiente</span>
                  <div class="loadingComponent" *ngIf="loading">
                    <app-loading [isLoading]="loading" />
                  </div>
                </button>
              </div>
            </div>

            <div [hidden]="step !== forgStep.registerNewPin" class="contentPin">
              <app-pin-code
                (pinCodeEmitter)="processPin($event)"
                [boardPinCode]="boardPinCode"
                [config]="pinCodeConfig"
              ></app-pin-code>
              <app-number-board
                (numberEmit)="receiveValue($event)"
              ></app-number-board>
              <button
                mat-raised-button
                class="submit-button"
                color="accent"
                aria-label="SEND RESET LINK"
                [disabled]="forgotPasswordForm.invalid || loading"
                (click)="verifyNewPin()"
              >
                <span *ngIf="!loading">ACEPTAR</span>
                <div class="loadingComponent" *ngIf="loading">
                  <app-loading [isLoading]="loading" />
                </div>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div *ngIf="!isProcessOk && loading" class="contentLoading">
        <div class="loadingComponent">
          <app-loading [isLoading]="!isProcessOk && loading" />
        </div>
      </div>

      <div fxLayout="column" fxLayoutGap="15px" *ngIf="isProcessError">
        <div>
          <h2>¡Lamentamos lo ocurrido!</h2>
          <p>Al parecer {{ stateProcess }}</p>
        </div>
      </div>
      <div *ngIf="!isForm" fxLayout="column" fxLayoutGap="15px">
        <br />
        <div>Cambio de contraseña exitoso</div>
        <div>Presiona el boton para continuar</div>
        <br />
        <button
          mat-raised-button
          [routerLink]="'/auth/login'"
          color="accent"
          aria-label="ENTRAR"
        >
          ACEPTAR
        </button>
      </div>
    </div>
    <div class="footer">Nubyy 2019, Todos los derechos reservados.</div>
  </div>
</div>
